export default function WebflowOauth(props: any) {

    return (
        <div>
            <h1>Webflow Sites</h1>
        </div>
    )
}